import dynamic from 'next/dynamic'

export const DynamicPersonalOrderSkeleton = dynamic(() =>
	import('./PersonalOrderSkeleton').then(({ PersonalOrderSkeleton }) => PersonalOrderSkeleton)
)
